export enum MapEntityType
{
    CUSTOMER = 1,
    BUILDING = 2,
    POLE = 3,
    TRANSFORMER = 4
}